import { useBackmarketHead } from '#imports'

import { NOINDEX_META_TAG } from '../utils/seo/constants'

export function useNoIndexMeta() {
  useBackmarketHead({
    meta: NOINDEX_META_TAG,
  })
}
